import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import Logo from "../root/logo";
import { injectIntl } from "react-intl";

function PageHeader({ logo, heading1, heading2, className, intl }) {
  return (
    <div className={cx("PageHeader", className)}>
      {logo && (
        <div className="PageHeader__LogoContainer">
          <Logo className="PageHeader__Logo" logo={logo} />
        </div>
      )}
      {heading1 && (
        <div className="PageHeader__Heading1Container">
          <div
            className="PageHeader__Heading1"
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage({ id: heading1 })
            }}
          />
        </div>
      )}
      {heading2 && (
        <div className="PageHeader__Heading2Container">
          <div
            className="PageHeader__Heading2"
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage({ id: heading2 })
            }}
          />
        </div>
      )}
    </div>
  );
}

PageHeader.propTypes = {
  logo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  heading1: PropTypes.string,
  heading2: PropTypes.string,
  className: PropTypes.string,
  intl: PropTypes.object.isRequired
};

export default injectIntl(PageHeader);



// WEBPACK FOOTER //
// ./src/modules/page/page-header.js